import { build } from "../../tools/ConfigBuilder";
import { lazy } from "react";

export default build([
	{
		path: "/profile/driver-trucks",
		component: lazy(() => import("./DriverTrucksPage")),
	},
	{
		path: "/profile/carriers/:carrierId/drivers/driverId:/trucks",
		component: lazy(() => import("./DriverTrucksPage")),
	},
]);
